import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from '../config/apolloClient';
import { ThemeProvider } from '../context/ThemeContext';
import { AuthProvider } from '../context/AuthContext';
import { PrivateRoute } from '../components/PrivateRoute';
import { Layout } from '../components/Layout';
import { LoginPage } from '../pages/LoginPage';
import { DashboardPage } from '../pages/DashboardPage';
import { SwitchControlPage } from '../pages/SwitchControlPage';
import { ConfiguracionPage } from '../pages/ConfiguracionPage';
import { AutorizacionPage } from '../pages/AutorizacionPage';
import { MontoDiarioPage } from '../pages/MontoDiarioPage';
import { MontoImpuestosPage } from '../pages/MontoImpuestosPage';
import { TaxConfigurationPage } from '../pages/TaxConfigurationPage';
import { HorariosPage } from '../pages/HorariosPage';
import { AjustarFacturasPage } from '../pages/AjustarFacturasPage';
import { GenerarFacturasPage } from '../pages/GenerarFacturasPage';
import { LogsPage } from '../pages/LogsPage';
import { UserManagementPage } from '../pages/UserManagementPage';
import { ControlPredictivoPage } from '../pages/ControlPredictivoPage';
import { InformesPage } from '../pages/InformesPage';
import { DocumentTrackingPage } from '../pages/DocumentTrackingPage';
import '../styles/BillingSystem.css';

const App: React.FC = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Ruta pública - Login */}
              <Route path="/login" element={<LoginPage />} />

              {/* Rutas protegidas */}
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout>
                      <DashboardPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/switch-control"
                element={
                  <PrivateRoute>
                    <Layout>
                      <SwitchControlPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/configuracion"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ConfiguracionPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/autorizacion"
                element={
                  <PrivateRoute>
                    <Layout>
                      <AutorizacionPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/monto-diario"
                element={
                  <PrivateRoute>
                    <Layout>
                      <MontoDiarioPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/monto-impuestos"
                element={
                  <PrivateRoute>
                    <Layout>
                      <MontoImpuestosPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/configuracion-impuestos"
                element={
                  <PrivateRoute>
                    <Layout>
                      <TaxConfigurationPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/horarios"
                element={
                  <PrivateRoute>
                    <Layout>
                      <HorariosPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/ajustar-facturas"
                element={
                  <PrivateRoute>
                    <Layout>
                      <AjustarFacturasPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/generar-facturas"
                element={
                  <PrivateRoute>
                    <Layout>
                      <GenerarFacturasPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/logs"
                element={
                  <PrivateRoute>
                    <Layout>
                      <LogsPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/control-predictivo"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ControlPredictivoPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/usuarios"
                element={
                  <PrivateRoute>
                    <Layout>
                      <UserManagementPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/informes"
                element={
                  <PrivateRoute>
                    <Layout>
                      <InformesPage />
                    </Layout>
                  </PrivateRoute>
                }
              />

              <Route
                path="/seguimiento-documentos"
                element={
                  <PrivateRoute>
                    <Layout>
                      <DocumentTrackingPage />
                    </Layout>
                  </PrivateRoute>
                }
              />

              {/* Redirigir rutas desconocidas */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default App;
